<template>
  <el-dialog :title="$t('addApp.title')" :visible.sync="dialogVisible" width="70%" :before-close="handleClose">
    <el-form :model="addAppInfo" :rules="rules" ref="addAppForm">
      <el-form-item :label="$t('addApp.appName')" prop="name">
        <el-input v-model="addAppInfo.name" :placeholder="$t('addApp.appNamePlaceholder')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('addApp.securityCode')" prop="securityCode">
        <el-input v-model="addAppInfo.securityCode" :placeholder="$t('addApp.securityCodePlaceholder')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('addApp.whiteList')" prop="whileListIp">
        <el-input v-model="addAppInfo.whileListIp" :placeholder="$t('addApp.whiteListPlaceholder')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('addApp.blackList')" prop="blackListIp">
        <el-input v-model="addAppInfo.blackListIp" :placeholder="$t('addApp.blackListPlaceholder')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('addApp.remark')" prop="remark">
        <el-input type="textarea" v-model="addAppInfo.remark" :placeholder="$t('addApp.remarkPlaceholder')"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveAppInfo">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveApp } from '@/api/dev/serviceBindingApi'

export default {
  name: 'AddApp',
  props: {
    callBackListener: String,
    callBackFunction: String
  },
  data() {
    return {
      dialogVisible: false,
      addAppInfo: {
        appId: '',
        name: '',
        securityCode: '',
        whileListIp: '',
        blackListIp: '',
        remark: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('addApp.appNameRequired'), trigger: 'blur' },
          { min: 2, max: 50, message: this.$t('addApp.appNameLength'), trigger: 'blur' }
        ],
        securityCode: [
          { max: 64, message: this.$t('addApp.securityCodeLength'), trigger: 'blur' }
        ],
        whileListIp: [
          { max: 200, message: this.$t('addApp.whiteListLength'), trigger: 'blur' }
        ],
        blackListIp: [
          { max: 200, message: this.$t('addApp.blackListLength'), trigger: 'blur' }
        ],
        remark: [
          { max: 200, message: this.$t('addApp.remarkLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.clearAddAppInfo()
    },
    handleClose() {
      this.dialogVisible = false
    },
    clearAddAppInfo() {
      this.addAppInfo = {
        name: '',
        securityCode: '',
        whileListIp: '',
        blackListIp: '',
        remark: ''
      }
      this.$refs.addAppForm && this.$refs.addAppForm.resetFields()
    },
    saveAppInfo() {
      this.$refs.addAppForm.validate(async (valid) => {
        if (valid) {
          try {
            if (this.callBackListener) {
              this.$emit(this.callBackListener, this.callBackFunction, this.addAppInfo)
              this.handleClose()
              return
            }

            await saveApp(this.addAppInfo)
            this.$message.success(this.$t('addApp.saveSuccess'))
            this.handleClose()
            this.$emit('success')
          } catch (error) {
            this.$message.error(error.message || this.$t('addApp.saveFailed'))
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.el-input,
.el-textarea {
  width: 100%;
}
</style>